import { useCallback, useEffect, useState } from 'react';
import BookSessionBlueSection from './BookSessionBlueSection';
import BookSessionMatchFlow from './BookSessionMatchFlow';
import LearnerAssessmentModal from './LearnerAssessmentModal';
import { fetchLearners } from '../../services/studentAccountService';

const BookSessionLearnerFlow = ({ embedded = false }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [assessmentOpen, setAssessmentOpen] = useState(false);
  const [modalLearnerLabel, setModalLearnerLabel] = useState('');
  const [user, setUser] = useState(null);
  const [learnerChoices, setLearnerChoices] = useState([]);

  useEffect(() => {
    const s = localStorage.getItem('user');
    if (!s) return;
    try {
      setUser(JSON.parse(s));
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchLearners()
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res) ? res : res?.learners || [];
        setLearnerChoices(list);
      })
      .catch(() => {
        if (!cancelled) setLearnerChoices([]);
      });
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  const bump = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  const openAssessment = useCallback((label) => {
    setModalLearnerLabel(label);
    setAssessmentOpen(true);
  }, []);

  const closeAssessment = useCallback(() => {
    setAssessmentOpen(false);
    setModalLearnerLabel('');
  }, []);

  // Keep the assessment and matching workflow on its dedicated booking page,
  // not inside the learner dashboard.
  if (embedded) {
    return null;
  }

  return (
    <>
      <BookSessionBlueSection
        embedded={embedded}
        learnerChoices={learnerChoices}
        onLaunchAssessment={openAssessment}
        showAssessment
      />
      <div className="w-full bg-white pb-12">
        <BookSessionMatchFlow
          refreshKey={refreshKey}
          onEditAssessment={openAssessment}
          onAfterRemove={bump}
        />
      </div>
      <LearnerAssessmentModal
        open={assessmentOpen}
        onClose={closeAssessment}
        learnerLabel={modalLearnerLabel}
        learnerChoices={learnerChoices}
        onLearnerLabelChange={setModalLearnerLabel}
        user={user}
        onPersisted={bump}
      />
    </>
  );
};

export default BookSessionLearnerFlow;
